import { render, staticRenderFns } from "./sceTabs.vue?vue&type=template&id=60797e12&scoped=true"
import script from "./sceTabs.vue?vue&type=script&lang=js"
export * from "./sceTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60797e12",
  null
  
)

export default component.exports